import { PRESETS, rulesKey, type Ruleset } from '@ic/engine';
import { api, auth } from './auth';
import { persisted } from './store';

/** Game modes published by admins (cached for offline use). */
export const publishedModes = persisted<Ruleset[]>('ic.modes', []);

export async function refreshModes() {
  try {
    const r = await api<{ modes: Ruleset[] }>('/modes');
    publishedModes.set(r.modes);
  } catch { /* offline: keep the cached list */ }
}

/** Every mode a normal player may pick: the presets plus the published ones. */
export function playableModes(): Ruleset[] {
  return [...PRESETS, ...publishedModes.get()];
}

/** Custom rules (from the Rule Editor or a share link) are for admins only. */
export function canPlay(rs: Ruleset): boolean {
  if (auth.get().admin) return true;
  const key = rulesKey(rs);
  return playableModes().some((m) => rulesKey(m) === key);
}
